import { IComposableChartsWidget } from 'wisestep-api';

import SalesTrendOrderBookBarChart from '../barCharts/SalesTrendOrderBookBarChart';
import TopClientsBarChart from '../barCharts/TopClientsBarChart';
import TotalCountOfPlacementsBarChart from '../barCharts/TotalCountOfPlacementsBarChart';
import ClientWiseOrderBookCountAndRevenueTable from '../tables/ClientWiseOrderBookCountAndRevenueTable';
import ClientWiseOrderBookCountTable from '../tables/ClientWiseOrderBookCountTable';
import ClientWiseOrderBookRevenueTable from '../tables/ClientWiseOrderBookRevenueTable';
import SalesByAMTable from '../tables/SalesByAMTable';
import SalesTrendOrderBook from '../tables/SalesTrendOrderBookTable';
import TopClientsTable from '../tables/TopClientsTable';
import TotalCountOfPlacementsTable from '../tables/TotalCountOfPlacementsTable';

export const salesTrendCharts: IComposableChartsWidget[] = [
  {
    name: 'Sales Trend Order Book Monthly',
    filters: {},
    type: 'table_sales_trend_order_book_monthly',
    category: 'clients',
    component: (
      <SalesTrendOrderBook
        clientsAnalyticsChartsProps={{ period: 'MONTH', currency: 'INR', quarter: '' }}
      />
    ),
  },
  {
    name: 'Sales Trend OrderBook Monthly',
    filters: {},
    type: 'barchart_sales_trend_order_book_monthly',
    category: 'clients',
    component: (
      <SalesTrendOrderBookBarChart
        clientsAnalyticsChartsProps={{ period: 'MONTH', currency: 'INR', quarter: '' }}
      />
    ),
  },
  {
    name: 'Sales Trend Order Book Quarterly',
    filters: {},
    type: 'table_sales_trend_order_book_quarterly',
    category: 'clients',
    component: (
      <SalesTrendOrderBook
        clientsAnalyticsChartsProps={{ period: 'QUARTER', currency: 'INR', quarter: '' }}
      />
    ),
  },
  {
    name: 'Sales Trend Order Book Quarterly',
    filters: {},
    type: 'barchart_sales_trend_order_book_quarterly',
    category: 'clients',
    component: (
      <SalesTrendOrderBookBarChart
        clientsAnalyticsChartsProps={{ period: 'QUARTER', currency: 'INR', quarter: '' }}
      />
    ),
  },
  {
    name: 'Sales Trend Order Book Yearly',
    filters: {},
    type: 'table_sales_trend_order_book_yearly',
    category: 'clients',
    component: (
      <SalesTrendOrderBook
        clientsAnalyticsChartsProps={{ period: 'YEAR', currency: 'INR', quarter: '' }}
      />
    ),
  },
  {
    name: 'Sales Trend Order Book Quarterly',
    filters: {},
    type: 'barchart_sales_trend_order_book_yearly',
    category: 'clients',
    component: (
      <SalesTrendOrderBookBarChart
        clientsAnalyticsChartsProps={{ period: 'YEAR', currency: 'INR', quarter: '' }}
      />
    ),
  },
];
export const placementsCharts: IComposableChartsWidget[] = [
  {
    name: 'Placements Monthly',
    filters: {},
    type: 'table_count_of_placements_monthly',
    category: 'clients',
    component: (
      <TotalCountOfPlacementsTable
        clientsAnalyticsChartsProps={{ period: 'MONTH', currency: 'INR', quarter: '' }}
      />
    ),
  },
  {
    name: 'Placements Monthly',
    filters: {},
    type: 'barchart_placements_monthly',
    category: 'clients',
    component: (
      <TotalCountOfPlacementsBarChart
        clientsAnalyticsChartsProps={{ period: 'MONTH', currency: 'INR', quarter: '' }}
      />
    ),
  },
  {
    name: 'Placements Quarterly',
    filters: {},
    type: 'table_count_of_placements_quarterly',
    category: 'clients',
    component: (
      <TotalCountOfPlacementsTable
        clientsAnalyticsChartsProps={{ period: 'QUARTER', currency: 'INR', quarter: '' }}
      />
    ),
  },
  {
    name: 'Placements Quarterly',
    filters: {},
    type: 'barchart_placements_quarterly',
    category: 'clients',
    component: (
      <TotalCountOfPlacementsBarChart
        clientsAnalyticsChartsProps={{ period: 'QUARTER', currency: 'INR', quarter: '' }}
      />
    ),
  },
  {
    name: 'Placements Yearly',
    filters: {},
    type: 'table_count_of_placements_yearly',
    category: 'clients',
    component: (
      <TotalCountOfPlacementsTable
        clientsAnalyticsChartsProps={{ period: 'YEAR', currency: 'INR', quarter: '' }}
      />
    ),
  },
  {
    name: 'Placements Yearly',
    filters: {},
    type: 'barchart_placements_yearly',
    category: 'clients',
    component: (
      <TotalCountOfPlacementsBarChart
        clientsAnalyticsChartsProps={{ period: 'YEAR', currency: 'INR', quarter: '' }}
      />
    ),
  },
];
export const top20Clients: IComposableChartsWidget[] = [
  {
    name: 'Top Clients',
    filters: {},
    type: 'table_top_clients',
    category: 'clients',
    component: (
      <TopClientsTable clientsAnalyticsChartsProps={{ period: '', currency: 'INR', quarter: '' }} />
    ),
  },
  {
    name: 'Top Clients',
    filters: {},
    type: 'barchart_top_clients',
    category: 'clients',
    component: (
      <TopClientsBarChart
        clientsAnalyticsChartsProps={{ period: '', currency: 'INR', quarter: '' }}
      />
    ),
  },
];
export const clientWiseOrderBookCharts: IComposableChartsWidget[] = [
  {
    name: 'Client Wise OrderBook',
    filters: {},
    type: 'table_client_wise_order_book_current_quarter_withFilter',
    category: 'clients',
    component: (
      <ClientWiseOrderBookCountTable
        clientsAnalyticsChartsProps={{ period: '', currency: 'INR', quarter: '' }}
      />
    ),
  },
  {
    name: 'Client Wise Revenue OrderBook',
    filters: {},
    type: 'table_client_wise_order_book_revenue_withFilter',
    category: 'clients',
    component: (
      <ClientWiseOrderBookRevenueTable
        clientsAnalyticsChartsProps={{ period: '', currency: 'INR', quarter: '' }}
      />
    ),
  },
  {
    name: 'Client Wise Revenue and Count OrderBook',
    filters: {},
    type: 'table_client_wise_order_book_count_revenue_withFilter',
    category: 'clients',
    component: (
      <ClientWiseOrderBookCountAndRevenueTable
        clientsAnalyticsChartsProps={{ period: '', currency: 'INR', quarter: '' }}
      />
    ),
  },
];

export const salesByAMCharts: IComposableChartsWidget[] = [
  {
    name: 'Sales By Account Manager - Monthly',
    filters: {},
    type: 'table_sales_by_account_manager_withFilter',
    category: 'clients',
    component: (
      <SalesByAMTable clientsAnalyticsChartsProps={{ period: '', currency: 'INR', quarter: '' }} />
    ),
  },
];

export const clientsDashboardKeysObjectList = [
  ...salesTrendCharts,
  ...salesByAMCharts,
  ...clientWiseOrderBookCharts,
  ...top20Clients,
  ...placementsCharts,
];
